<template>
  <CollapsibleSection body-class="flex flex-col gap-3">
    <Field
      :value="true"
      :unchecked-value="false"
      v-slot="{ field }"
      name="iSGCCCitizen"
      type="checkbox"
    >
      <label>
        <input
          class="accent-primary"
          type="checkbox"
          name="iSGCCCitizen"
          v-bind="field"
          @change="(e) => handleGccChange(field.checked, setFieldValue, values)"
        />
        {{ $t('gccCitizen') }}
      </label>
    </Field>
    <div class="w-full flex flex-col gap-y-2">
      <h3 class="text-lg">{{ $t('searchBy') }}</h3>
      <div class="w-full flex gap-x-5">
        <Field
          :key="r.value"
          :value="r.value"
          :disabled="values.iSGCCCitizen"
          v-for="r in identifierOptions"
          name="selectIdentificater"
          type="radio"
          v-slot="{ field }"
        >
          <label class="flex gap-x-2">
            <input
              :disabled="values.iSGCCCitizen"
              class="accent-primary"
              type="radio"
              name="selectIdentificater"
              v-bind="field"
            />
            {{ $t(r.label) }}
          </label>
        </Field>
      </div>
    </div>
    <div v-if="!values.iSGCCCitizen" class="w-full flex flex-col gap-y-2">
      <h3 class="text-lg">{{ $t('selectTheType') }}</h3>
      <div class="w-full flex gap-x-5">
        <Field :value="1" name="fileModuleId" type="radio" v-slot="{ field, value }">
          <label class="flex gap-x-2">
            <input
              class="accent-primary"
              type="radio"
              v-bind="field"
              @change="
                () => {
                  onFileModuleIdChange(value)
                  fileValidityStore.resetFileTypeFields(resetField)
                }
              "
            />
            {{ $t('residency') }}
          </label>
        </Field>
        <Field :value="2" name="fileModuleId" type="radio" v-slot="{ field, value }">
          <label class="flex gap-x-2">
            <input
              class="accent-primary"
              type="radio"
              v-bind="field"
              @change="
                () => {
                  onFileModuleIdChange(value)
                  fileValidityStore.resetFileTypeFields(resetField)
                }
              "
            />
            {{ $t('visa') }}
          </label>
        </Field>
        <Field
          v-if="values.selectIdentificater !== 2"
          :value="true"
          name="fileModuleId"
          type="radio"
          v-slot="{ field, value }"
        >
          <label class="flex gap-x-2">
            <input
              class="accent-primary"
              type="radio"
              v-bind="field"
              @change="
                () => {
                  onFileModuleIdChange(value)
                  fileValidityStore.resetFileTypeFields(resetField)
                }
              "
            />
            {{ $t('emiratesID') }}
          </label>
        </Field>
      </div>
    </div>
  </CollapsibleSection>
</template>

<script setup>
import { useFileValidityStore } from '@/stores/file_validity'
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import { Field } from 'vee-validate'

defineProps({
  initialValues: { type: Object },
  errors: {
    type: Object
  },
  values: {
    type: Object
  },
  resetField: {
    type: Function
  },
  setFieldValue: {
    type: Function
  }
})

const fileValidityStore = useFileValidityStore()

const identifierOptions = [
  { value: 1, label: 'fileNumber' },
  { value: 2, label: 'passportInformation' }
]

function handleGccChange(checked, setFieldValue) {
  setFieldValue('selectIdentificater', checked ? 2 : 1)
}

function onFileModuleIdChange(value) {
  fileValidityStore.inquiryAboutIDN = value === 3
}
</script>

<style lang="scss" scoped></style>
